import ReactDOM from "react-dom"
import React, { Suspense } from "react"

import { isLocal } from "@/utils/helpers/formatters"
import { ErrorBoundary } from "@/utils/ErrorBoundary"
import MainLayoutLoader from "./components/Loader/MainLayoutLoader"
import * as Yup from "yup"

const MemberOnline = React.lazy(
  () => import(/* webpackChunkName: "app" */ "./App")
)
const Registration = React.lazy(
  () => import(/* webpackChunkName: "register" */ "./Register")
)
const RegistrationMfa = React.lazy(
  () => import(/* webpackChunkName: "register-mfa" */ "./RegisterMfa")
)
const Page = React.lazy(() => import(/* webpackChunkName: "page" */ "./Page"))

const Components = React.lazy(
  () => import(/* webpackChunkName: "components" */ "./Components")
)

const OktaTransactionMfa = React.lazy(
  () =>
    import(
      /* webpackChunkName: "okta-transaction-mfa" */ "./OktaTransactionMfa"
    )
)

Yup.setLocale({
  mixed: {
    required: "This field is required",
    oneOf: "This field is required",
  },
})

const AppMap = {
  "member-online-app": MemberOnline,
  "member-online-register-legacy": Registration,
  "member-online-register": RegistrationMfa,
  "member-online-page": Page,
  "member-online-components": Components,
  "okta-transaction-mfa": OktaTransactionMfa,
}

function FallbackLoader() {
  // Don't show loader for MFA callback - it just processes and redirects
  const isMfaCallback =
    window.location.hash.includes("/mfa-callback") ||
    window.location.pathname.endsWith("/mfa-callback")
  if (isMfaCallback) {
    return null
  }

  return (
    <main className="main" id="main">
      <div className="content-container">
        <MainLayoutLoader />
      </div>
    </main>
  )
}

function init(elem: HTMLElement) {
  if (!window?.GESB_MemberOnlineConfig) {
    return console.error(
      `Missing globals GESB_MemberOnlineConfig. If running locally make sure to follow the instructions in README.md and that the \
request to the Matrix url https://mol-uat.gesb.wa.gov.au is not being prevented.`
    )
  }

  isLocal() && console.log(window.GESB_MemberOnlineConfig)

  const App = AppMap[elem.id as keyof typeof AppMap]
  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Suspense fallback={<FallbackLoader />}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </React.StrictMode>,
    elem
  )
}

const container = Object.keys(AppMap).reduce<HTMLElement | null>(
  (elem, name) => elem || document.getElementById(name),
  null
)

if (container) {
  init(container)
}
